// 节点资产概览区块 - 简体中文
export default {
  asset: {
    totalValue: "资产总价值",
    totalExplain:
      "地址总资产余额是根据本系统已收录的币种价值，按地址持有的所有主币和代币折算USDT的总余额",
    supportedPrefix: "系统当前已支持",
    supportedLinkText: "317个币种",
    tronNote: "Tron链币种数据当前仅支持TRX、USDT",
    updateSuffix: " 更新",
  },
  balance: {
    mainBalanceSuffix: "余额:",
    usdtBalance: "USDT余额:",
    btcBalance: "BTC余额",
    approxUSDT: "(≈{value}\u00A0USDT)",
    currentBalancePrefix: "当前余额：",
    remark: "备注：",
  },
};
